import type { GetAliiNotificationCategoryResponse } from '$lib/models/alii-notification-category/types';
import { fetchWithAuth } from '$lib/utils/http/httpUtil';
import { showToast } from '$lib/helpers/toastrHelper';
import { persisted } from 'svelte-persisted-store';
import { get } from 'svelte/store';

export function createAliiNotificationCategoryStore() {
  const baseUrl: string = '/api/alii-notification-category';

  const initial: GetAliiNotificationCategoryResponse[] = [];
  const store = persisted('aliiNotificationCategoryStore', initial, {
    storage: 'session',
  });

  return {
    get: async (): Promise<GetAliiNotificationCategoryResponse[]> => {
      const sessionData = get(store);
      if (sessionData.length > 0) return sessionData;

      const response = await fetchWithAuth(baseUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorMessage = `Failed to fetch notification categories (HTTP ${response.status})`;
        showToast({
          title: 'Error',
          message: errorMessage,
          type: 'error'
        });
        return [];
      }

      try {
        const data = (await response.json()).sort(function (a: GetAliiNotificationCategoryResponse, b: GetAliiNotificationCategoryResponse) {
          if (a.name === undefined && b.name !== undefined) {
            return 1;
          }
          if (a.name !== undefined && b.name === undefined) {
            return -1;
          }
          if (a.name === undefined && b.name === undefined) {
            if (a.id < b.id) {
              return -1;
            }
            if (a.id > b.id) {
              return 1;
            }
            return 0;
          }
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        store.set(data);
        return data;
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'Failed to load notification categories',
          type: 'error'
        });
        return [];
      }
    },
  };
}

export const aliiNotificationCategoryStore = createAliiNotificationCategoryStore();
